var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { observable, action } from "mobx";
import { ArrayHelper } from "sb-helpers";
import { PushMessageTypes } from "sb-legacy-integration";
import { Parser } from "../parsers";
import { QALiveSlipSelection, PulseBetMarketComponentData, PulseBetMarketAdditionalData } from "../models";
import { StakeViewModel, StakeCurrencyContainer, BetPlacementStatus } from "../../blocks/PulseBetMarkets/data"; //TO DO  STORE should not use local block objects
import Debounce from "debounce-decorator";
import { EventsManager } from "sb-js-extends";
var PulseBettingStore = /** @class */ (function () {
    function PulseBettingStore() {
        this.name = "PulseBettingStore";
        this.masterEventId = "0";
        this.eventsToUpdate = [];
        this.events = [];
        this.infoMessages = [];
        this.successfullUpdateEventsCallback = this.successfullUpdateEventsCallback.bind(this);
        this.pulsebetsDataForComponents = [];
        this.branchId = "1";
        this.eventIds = [];
        this.isUserLogged = false;
        this.awaitingCallback = [];
        this.eventsManager = new EventsManager();
    }
    PulseBettingStore.prototype.clear = function () {
        this.eventIds = [];
        this.events = [];
        this.infoMessages = [];
        clearTimeout(this.updateEventsTimeout);
        this.pulsebetsDataForComponents = [];
        this.eventsManager.removeEventListener("onPulseBetWaitingResponse", this, true);
        this.eventsManager.removeEventListener("onBonusMoneyBetting", this, true);
    };
    PulseBettingStore.prototype.setFacade = function (facade) {
        if (typeof this.facade === "undefined" && facade) {
            this.facade = facade;
            this.facade.addSubscriber(this.subscribeToPush, this.name, PushMessageTypes.Odds, {
                SubscriberEvents: this.eventsToUpdate, IsBetSlip: false
            });
        }
    };
    PulseBettingStore.prototype.setEvents = function (eventIds) {
        var e_1, _a;
        this.eventIds = eventIds;
        try {
            for (var eventIds_1 = __values(eventIds), eventIds_1_1 = eventIds_1.next(); !eventIds_1_1.done; eventIds_1_1 = eventIds_1.next()) {
                var ev = eventIds_1_1.value;
                this.eventsToUpdate[ev.id] = {
                    ID: ev.id,
                    updateString: ev.id.toString(),
                    /* istanbul ignore next */
                    getUpdateString: function () {
                        /* istanbul ignore next */
                        return this.updateString;
                    }
                };
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (eventIds_1_1 && !eventIds_1_1.done && (_a = eventIds_1.return)) _a.call(eventIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    PulseBettingStore.prototype.createStakeViewModel = function (eventId) {
        var _this = this;
        var index = this.currency.pulseBettingStakeValuesSeries.findIndex(function (stake) { return stake === _this.currency.defaultStake; });
        return new StakeViewModel({
            stakeValue: this.currency.defaultStake,
            currencySign: this.currencySign,
            eventId: eventId,
            index: index,
            isMinusDisabled: index <= 0,
            isPlusDisabled: index === this.currency.pulseBettingStakeValuesSeries.length - 1
        });
    };
    PulseBettingStore.prototype.removeFromWaitingBets = function (eventId) {
        var index = this.awaitingCallback.findIndex(function (bet) { return bet.eventId === eventId; });
        if (index >= 0) {
            this.awaitingCallback.splice(index, 1);
        }
        if (eventId === -1) {
            this.awaitingCallback.splice(0, 1);
        }
        if (this.awaitingCallback.length) {
            setTimeout(this.awaitingCallback[0].func, 250);
        }
    };
    PulseBettingStore.prototype.addToMessages = function (messageText) {
        this.infoMessages = [];
        messageText && this.infoMessages.push(messageText);
    };
    // Method implementation is in progress, the periods population is commented out.
    PulseBettingStore.prototype.setpulseBetMarketViewModelList = function () {
        var e_2, _a;
        var _loop_1 = function (event_1) {
            if (event_1.spLines.length === 3) {
                var pulseComponentData = this_1.pulsebetsDataForComponents.find(function (comp) { return comp.pulseBetMetadata.marketId === event_1.id; });
                if (pulseComponentData) {
                    pulseComponentData.pulseBetMetadata.periods = this_1.formatPeriods(event_1.spLines);
                    pulseComponentData.winings.winnings = pulseComponentData.wrappedCalculatedPeriods.map(function (period, index) { return ({
                        winningValue: period.formatedWin,
                        winningStatus: period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                        periodNumber: index
                    }); });
                    pulseComponentData.placeBetHandler = this_1.getPulseBetMarketHandler(this_1.isUserLogged, event_1, pulseComponentData.stakeInputData.stakeValue);
                    pulseComponentData.pulseBetMetadata.isDanger = event_1.isDanger;
                }
                else {
                    var stakeViewModel = this_1.createStakeViewModel(event_1.id);
                    var periods = this_1.formatPeriods(event_1.spLines);
                    var duration = periods[2].endTimeInMilli - periods[0].startTimeInMilli;
                    this_1.pulsebetsDataForComponents.push(new PulseBetMarketComponentData(stakeViewModel, new PulseBetMarketAdditionalData({
                        durationInMilli: duration, name: event_1.typeName, marketId: event_1.id, branchID: this_1.branchId, currencySign: this_1.currencySign,
                        periods: periods,
                        typeId: event_1.typeId,
                        isDanger: event_1.isDanger
                    }), 1000000, this_1.getAvailableFreeBets(event_1), this_1.getPulseBetMarketHandler(this_1.isUserLogged, event_1, stakeViewModel.stakeValue)));
                }
            }
        };
        var this_1 = this;
        try {
            for (var _b = __values(this.events), _c = _b.next(); !_c.done; _c = _b.next()) {
                var event_1 = _c.value;
                _loop_1(event_1);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    PulseBettingStore.prototype.getAvailableFreeBets = function (event) {
        var freeBets = this.betslipUtil.getAvailableFreeBetsForPulse(event);
        var freePulseBets = Parser.PulseFreeBetInfoParser(event.typeId, freeBets);
        return freePulseBets;
    };
    PulseBettingStore.prototype.triggerStakeWinningsAnimation = function (eventId) {
        var pulseBetdata = this.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        /* istanbul ignore next */
        if (pulseBetdata) {
            /* istanbul ignore next */
            pulseBetdata.onStakeChangeFading = true;
        }
    };
    PulseBettingStore.prototype.getPulseBetMarketHandler = function (isUserLogged, event, stakeValue) {
        if (isUserLogged) {
            return this.placeBet.bind(this, event.spLines, stakeValue);
        }
        else {
            return this.navHandler.openResponsiveLogin;
        }
    };
    PulseBettingStore.prototype.placeBet = function (lines, stake) {
        this.awaitingCallback.push({
            eventId: lines[0].eventId,
            func: this.betslipUtil.addQAInitilizedSelectionToBetSlip.bind(this.betslipUtil, { lines: lines, stake: stake })
        });
        /* istanbul ignore next */
        this.eventsManager.dispatchEvent("onPulseBetPlacementResult", {
            status: BetPlacementStatus.InProcess,
            eventId: lines[0].eventId,
            ticketId: 0,
            timeInterval: "0-0",
            errorMessage: ""
        }, true);
        if (this.awaitingCallback.length === 1) {
            /* istanbul ignore next */
            this.awaitingCallback[0].func();
        }
    };
    PulseBettingStore.prototype.formatPeriods = function (lines) {
        var e_3, _a;
        if (!lines || !lines[0]) {
            return [];
        }
        var gameProgressMs = lines[0].qaParameter1 * 1000;
        var periods = [];
        try {
            for (var lines_1 = __values(lines), lines_1_1 = lines_1.next(); !lines_1_1.done; lines_1_1 = lines_1.next()) {
                var line = lines_1_1.value;
                var endTime = (line.qaParameter1 * 1000) - gameProgressMs + (line.qaParameter2 * 1000);
                periods.push({
                    europeanOdds: +this.oddsUtil.convertFormat(+line.odds, parseInt(line.eventTypeId, 10), line.lineTypeId, undefined, 1, undefined, parseInt(line.branchId, 10), undefined, undefined),
                    startTimeInMilli: (line.qaParameter1 * 1000) - gameProgressMs,
                    endTimeInMilli: endTime
                });
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (lines_1_1 && !lines_1_1.done && (_a = lines_1.return)) _a.call(lines_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return periods;
    };
    Object.defineProperty(PulseBettingStore, "getInstance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: true,
        configurable: true
    });
    PulseBettingStore.prototype.subscribeToPush = function (data) {
        var events = ArrayHelper.ArrayOf(data, Parser.QAEventInfoParser.bind(Parser));
        this.updateStore(events);
        if (this.facade) {
            this.facade.clearDebounce(this.name);
        }
        this.updateBetSlipLines(true);
    };
    PulseBettingStore.prototype.updateStore = function (events) {
        var e_4, _a;
        var _loop_2 = function (event_2) {
            var ev = this_2.events.find(
            /* istanbul ignore next */
            function (evt) { return evt.id === event_2.id; });
            if (!ev) {
                return "continue";
            }
            ev.lines = event_2.lines;
        };
        var this_2 = this;
        try {
            for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
                var event_2 = events_1_1.value;
                _loop_2(event_2);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    PulseBettingStore.prototype.updateBetSlipLines = function (isFromPush) {
        var e_5, _a, e_6, _b;
        if (this.events.length > 0) {
            var request = [];
            var viewKey = 0;
            var responseArray = [];
            try {
                for (var _c = __values(this.events), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var event_3 = _d.value;
                    try {
                        for (var _e = __values(event_3.lines), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var line = _f.value;
                            request.push([false, viewKey, event_3.id, event_3.typeId, line.id, line.odds, 0, 0, false, "0_" + this.masterEventId + "_0", false, true, line.lineTypeId].join(","));
                            responseArray[viewKey++] = { event: event_3, line: line };
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_5) throw e_5.error; }
            }
            this.dataComposite.bettingPageMethods.updateRegularCartItems(request.join("@"), this.successfulUpdateRegularCartItemCallback.bind(this, responseArray), this.errorCallback);
            if (!isFromPush) {
                this.setUpdateEventsData();
            }
        }
    };
    PulseBettingStore.prototype.setUpdateEventsData = function () {
        this.updateEventsTimeout = setTimeout(this.updateBetSlipLines, 5000);
    };
    PulseBettingStore.prototype.successfullUpdateEventsCallback = function (response) {
        var data = eval(response);
        this.events = ArrayHelper.ArrayOf(data, Parser.QAEventInfoParser.bind(Parser));
        this.updateBetSlipLines();
    };
    /**istanbuld ignore next */
    PulseBettingStore.prototype.successfulUpdateRegularCartItemCallback = function (request, response) {
        var jsonData = eval(response);
        for (var key in jsonData) {
            if (jsonData[key]) {
                if (jsonData[key] !== "-1") {
                    if (request[key]) {
                        var event_4 = request[key].event;
                        var evt = event_4;
                        evt.masterEventId = this.masterEventId;
                        var item = Parser.QALiveSlipSelectionParser(evt, jsonData[key]);
                        item.lineId = request[key].line.id;
                        item.odds = item.odds || request[key].line.odds;
                        this.parseUpdateRegularCartItem(item);
                    }
                }
                else {
                    this.removeFromPulseBets(request[key].event.id);
                }
            }
        }
        this.setpulseBetMarketViewModelList();
    };
    PulseBettingStore.prototype.removeFromPulseBets = function (eventId) {
        var indexToRemove = this.eventIds.findIndex(function (eventModel) { return eventModel.id === eventId; });
        if (indexToRemove !== -1) {
            this.eventIds.splice(indexToRemove, 1);
        }
        indexToRemove = this.events.findIndex(function (qaEvent) { return qaEvent.id === eventId; });
        if (indexToRemove !== -1) {
            this.events.splice(indexToRemove, 1);
        }
        indexToRemove = this.pulsebetsDataForComponents.findIndex(function (pbComponent) { return pbComponent.pulseBetMetadata.marketId === eventId; });
        if (indexToRemove !== -1) {
            this.pulsebetsDataForComponents[indexToRemove].resetFreePulseBets();
            this.pulsebetsDataForComponents.splice(indexToRemove, 1);
        }
    };
    PulseBettingStore.prototype.errorCallback = function (response) {
    };
    //TODO: write tests
    /*istanbul ignore next */
    PulseBettingStore.prototype.parseUpdateRegularCartItem = function (item) {
        var observableEvent = this.events.find(function (ev) { return ev.id === item.eventId; });
        /* istanbul ignore next */
        if (observableEvent) {
            if (observableEvent.spLines.length) {
                var index = observableEvent.spLines.findIndex(function (spLine) { return spLine.lineId === item.lineId; });
                if (index >= 0) {
                    /* istanbul ignore next */
                    observableEvent.spLines[index] = item;
                }
                else {
                    observableEvent.spLines.push(item);
                }
            }
            else {
                observableEvent.spLines.push(item);
            }
            observableEvent.isDanger = item.danger;
            return observableEvent;
        }
        /* istanbul ignore next */
        return observableEvent;
    };
    /**istanbul ignore next */
    PulseBettingStore.prototype.setParams = function (masterEventId, events) {
        var e_7, _a;
        if (this.masterEventId === masterEventId && events.length === this.eventIds.length) {
            return;
        }
        this.clear();
        this.eventsManager.addEventListener("onBonusMoneyBetting", this, this.addToMessages, true);
        this.eventsManager.addEventListener("onPulseBetWaitingResponse", this, this.removeFromWaitingBets, true);
        this.masterEventId = masterEventId;
        this.eventIds = events;
        var updateString = "";
        try {
            for (var events_2 = __values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
                var item = events_2_1.value;
                updateString += item.id + "#" + item.type + "@";
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (events_2_1 && !events_2_1.done && (_a = events_2.return)) _a.call(events_2);
            }
            finally { if (e_7) throw e_7.error; }
        }
        if (updateString.length) {
            this.dataComposite.pageMethods.UpdateEvents(updateString, this.successfullUpdateEventsCallback, this.errorCallback);
        }
    };
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], PulseBettingStore.prototype, "isUserLogged", void 0);
    __decorate([
        observable,
        __metadata("design:type", StakeCurrencyContainer)
    ], PulseBettingStore.prototype, "currency", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "eventIds", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "events", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "infoMessages", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "pulsebetsDataForComponents", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "awaitingCallback", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "setpulseBetMarketViewModelList", null);
    __decorate([
        Debounce(10),
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "triggerStakeWinningsAnimation", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Array)
    ], PulseBettingStore.prototype, "formatPeriods", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "updateStore", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "updateBetSlipLines", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "successfullUpdateEventsCallback", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Object]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "successfulUpdateRegularCartItemCallback", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [QALiveSlipSelection]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "parseUpdateRegularCartItem", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Array]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "setParams", null);
    return PulseBettingStore;
}());
export { PulseBettingStore };
//# sourceMappingURL=PulseBettingStore.js.map